import * as React from 'react';

function SvgIconListDelete(props) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.09 15.7a1.32 1.32 0 01-.1-.1c.037.037.067.072.1.1zm-.172-.072zm13.895-13.16a.673.673 0 00-.468-.19h-3.286V1.256C12.059.563 11.496 0 10.804 0h-5.61C4.502 0 3.94.563 3.94 1.255v1.024H.637a.638.638 0 000 1.274H1.2v11.092c0 .693.562 1.255 1.255 1.255h11.268c.693 0 1.255-.562 1.255-1.255V3.553h.367c.35 0 .655-.285.655-.637a.629.629 0 00-.187-.449zm-10.62-1.21h5.605V2.29H5.193V1.26zm8.528 13.386H2.455V3.554H13.72v11.09zm-5.73-8.955a.64.64 0 00-.64.641v5.946a.64.64 0 101.281 0V6.33a.64.64 0 00-.64-.64zm-3.471 0a.64.64 0 00-.641.641v5.946a.64.64 0 101.282 0V6.33a.64.64 0 00-.641-.64zm6.907 0a.64.64 0 00-.641.641v5.946a.64.64 0 101.282 0V6.33a.64.64 0 00-.641-.64z" />
    </svg>
  );
}

export default SvgIconListDelete;
